import React from 'react';
import TextBoxControl from '../common/TextBoxControl';
import SelectControl from '../common/SelectControl';
import CheckBoxControl from '../common/CheckBoxControl';
import PropTypes from 'prop-types';
import {
  EmailRegex,
  IsStringValid,
  ORGANISATION_GROUP_ID_ALUXOR,
  ORGANISATION_GROUP_ID_NOLANS,
  validationCreator
} from "../../constants";

// Discount bands available to fabricator organisations. Deliberately a fixed
// list rather than a lookup - SelectControl hides itself when options is empty.
export const FabricatorDiscountOptions = [
  { value: 0, label: '0%' },
  { value: 6, label: '6%' },
  { value: 12, label: '12%' },
];

export const AdminValidationRules = {

  shortName: {
    validator: (val, state, props) => {
      return !IsStringValid(val) ? validationCreator(false, 'Please enter a valid short name') : validationCreator();
    }
  },
  myobCompanyName: {
    validator: (val, state, props) => {      
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val) ? validationCreator(false, 'Please enter a valid MYOB company name') : validationCreator();
    }
  },
  discountBand1: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }  
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a valid discount') : validationCreator();
    }
  },discountBand2: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a valid discount') : validationCreator();
    }
  },discountBand3: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a valid discount') : validationCreator();
    }
  },discountBand4: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a valid discount') : validationCreator();
    }
  },discountBand5: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a valid discount') : validationCreator();
    }
  },
  creditLimit: {    
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a credit limit') : validationCreator();
    }
  },
  rating: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /^([0-5]{1})$/g) ? validationCreator(false, 'Please enter a rating (1-5)') : validationCreator();
    }
  },
  creditTermsId: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a credit limit') : validationCreator();
    }
  },
  statusCreditApplicationId: {
    validator: (val, state, props) => {
      if(state.isNolans){
        return validationCreator();
      }
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a credit application status') : validationCreator();
    }
  },
  organisationStatusId: {
    validator: (val, state, props) => {
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter a client status') : validationCreator();
    }
  },
  organisationGroupId: {
    validator: (val, state, props) => {
      return !IsStringValid(val, /\d/g) ? validationCreator(false, 'Please enter an organisation group') : validationCreator();
    }
  },
  // Blank is allowed on both of these - it means no order summary is emailed to the group.
  organisationGroupPurchaseOrderEmail: {
    validator: (val, state, props) => {
      return IsStringValid(val) && !IsStringValid(val, EmailRegex)
        ? validationCreator(false, 'Please enter a valid purchase order email')
        : validationCreator();
    }
  },
  organisationGroupSalesOrderEmail: {
    validator: (val, state, props) => {
      return IsStringValid(val) && !IsStringValid(val, EmailRegex)
        ? validationCreator(false, 'Please enter a valid sales order email')
        : validationCreator();
    }
  }
};

export const CustomerAdminControl = (props) => {
  let {organisation, organisationGroups, validationMessages, handleFieldChange, creditTerms, handleSelectChange, style,
    creditApplicationStatuses, organisationStatuses, dispatchTypes, dispatchCentres, fabricMakers, powderCoaters, isNolans,
    deliveryRegions, couriers, userIsAdmin} = props;

  // The order emails belong to the group, so they are only editable from the group's primary organisation.
  // The id check also keeps them hidden on a new customer, where both ids are undefined and would compare equal.
  const canEditGroupOrderEmails = userIsAdmin && !!organisation.id
    && organisation.id === organisation.organisationGroupPrimaryOrganisationId;

  return (<div className={'pi-row'} style={style}>
    <div className={'pi-col-md-5'}>
      <h4>Client Administration</h4>
      <SelectControl
          labelText="Organisation Group"
          name="organisationGroupId"
          options={organisationGroups}
          onChange={(v) => handleSelectChange(v, 'organisationGroupId', (v) => v === null ? null : v.value)}
          value={organisation.organisationGroupId}
          validationMessages={validationMessages}
      />
      
      <TextBoxControl
        onChange={handleFieldChange}
        labelText="Short Name"
        value={organisation.shortName}
        name="shortName"
        validationMessages={validationMessages}
      />

      { userIsAdmin && <TextBoxControl
        onChange={handleFieldChange}
        labelText="MYOB Name"
        value={organisation.myobCompanyName}
        name="myobCompanyName"
        validationMessages={validationMessages}
      /> }

      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Frame (%)"
        value={organisation.discountBand1}
        name="discountBand1"
        validationMessages={validationMessages}
        type={'number'}
      /> }

      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Awning (%)"
        value={organisation.discountBand2}
        name="discountBand2"
        validationMessages={validationMessages}
        type={'number'}
      /> }

      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Accessories (%)"
        value={organisation.discountBand3}
        name="discountBand3"
        validationMessages={validationMessages}
        type={'number'}
      /> }

      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Spare Parts (%)"
        value={organisation.discountBand4}
        name="discountBand4"
        validationMessages={validationMessages}
        type={'number'}
      /> }

      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Services (%)"
        value={organisation.discountBand5}
        name="discountBand5"
        validationMessages={validationMessages}
        type={'number'}
      /> }


      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Credit Limit"
        value={organisation.creditLimit}
        name="creditLimit"
        validationMessages={validationMessages}
        type={'number'}
      /> }

      { !isNolans && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Rating (1-5)"
        value={organisation.rating}
        name="rating"
        validationMessages={validationMessages}
        type={'number'}
      /> }
      
      <CheckBoxControl
        onChange={handleFieldChange}
        labelText="Is Active"
        value={organisation.isActive}
        name="isActive"
      />

      <CheckBoxControl
        onChange={handleFieldChange}
        labelText="Wholesale Only"
        value={organisation.wholesaleOnly}
        name="wholesaleOnly"
        visible={organisation.organisationGroupId === ORGANISATION_GROUP_ID_ALUXOR}
      />

      { !isNolans &&  <CheckBoxControl
        onChange={handleFieldChange}
        labelText="Allowed Frame Only"
        value={organisation.isAllowedFrameOnly}
        name="isAllowedFrameOnly"
      /> }

        { !isNolans && <CheckBoxControl
          onChange={handleFieldChange}
          labelText="Enable Customer Quoting"
          value={organisation.enableCustomerInformation}
          name="enableCustomerInformation"
        /> }

      <CheckBoxControl
        onChange={handleFieldChange}
        labelText="Is Fabricator"
        value={organisation.isFabricator === true}
        name="isFabricator"
      />

      { organisation.isFabricator === true && <SelectControl
        validationMessages={validationMessages}
        labelText="Discount Applied"
        name="fabricatorDiscountApplied"
        options={FabricatorDiscountOptions}
        onChange={(v) => handleSelectChange(v, 'fabricatorDiscountApplied', (v) => v === null ? 0 : v.value)}
        value={organisation.fabricatorDiscountApplied}
      /> }

      <TextBoxControl
        onChange={handleFieldChange}
        labelText="Fabric Discount (%)"
        value={organisation.fabricDiscount}
        name="fabricDiscount"
        validationMessages={validationMessages}
        type={'number'}
      />

      <CheckBoxControl
          onChange={handleFieldChange}
          labelText="Require Acceptance of Terms"
          value={organisation.requiresAcceptedTerms}
          name="requiresAcceptedTerms"          
      />

    </div>
    <div className={'pi-col-md-1'}>
      &nbsp;
    </div>
    <div className={'pi-col-md-5'}>
      <h4>&nbsp;</h4>
      
      { !isNolans && <SelectControl
        clearable={true}
        deleteRemoves={true}
        backspaceRemoves={true}
        validationMessages={validationMessages}
        labelText="Credit Terms"
        name="creditTermsId"
        options={creditTerms}
        onChange={(v) => handleSelectChange(v, 'creditTermsId', (v) => v === null ? null : v.value)}
        value={organisation.creditTermsId}
      /> }

      { !isNolans && <SelectControl
        clearable={true}
        deleteRemoves={true}
        backspaceRemoves={true}
        validationMessages={validationMessages}
        labelText="Credit Application Status"
        name="statusCreditApplicationId"
        options={creditApplicationStatuses}
        onChange={(v) => handleSelectChange(v, 'statusCreditApplicationId', (v) => v === null ? null : v.value)}
        value={organisation.statusCreditApplicationId}
      /> }
      
      <SelectControl
        validationMessages={validationMessages}
        labelText="Client Status"
        name="organisationStatusId"
        options={organisationStatuses}
        onChange={(v) => handleSelectChange(v, 'organisationStatusId', (v) => v === null ? null : v.value)}
        value={organisation.organisationStatusId}
      />

      <SelectControl
        clearable={true}
        deleteRemoves={true}
        backspaceRemoves={true}
        validationMessages={validationMessages}
        labelText="Default Dispatch"
        name="dispatchTypeId"
        options={dispatchTypes}
        onChange={(v) => handleSelectChange(v, 'dispatchTypeId', (v) => v === null ? null : v.value)}
        value={organisation.dispatchTypeId}
      />

      <SelectControl
        clearable={true}
        deleteRemoves={true}
        backspaceRemoves={true}
        validationMessages={validationMessages}
        labelText="Delivery Region"
        name="deliveryRegionId"
        options={deliveryRegions || []}
        onChange={(v) => handleSelectChange(v, 'deliveryRegionId', (v) => v === null ? null : v.value)}
        value={organisation.deliveryRegionId}
      />

      <SelectControl
        clearable={true}
        deleteRemoves={true}
        backspaceRemoves={true}
        validationMessages={validationMessages}
        labelText="Default Courier"
        name="defaultCourierId"
        options={couriers || []}
        onChange={(v) => handleSelectChange(v, 'defaultCourierId', (v) => v === null ? null : v.value)}
        value={organisation.defaultCourierId}
      />

      <TextBoxControl
        onChange={handleFieldChange}
        labelText="Notes"
        value={organisation.notes}
        name="notes"
        validationMessages={validationMessages}
      />

      <TextBoxControl
        onChange={handleFieldChange}
        labelText="Standard Order Note"
        value={organisation.standardOrderNote}
        name="standardOrderNote"
        validationMessages={validationMessages}
      />

      { !isNolans &&  <SelectControl
          clearable={true}
          deleteRemoves={true}
          backspaceRemoves={true}
          validationMessages={validationMessages}
          labelText="Is a Fabric Maker"
          name="fabricMakerId"
          options={fabricMakers}
          onChange={(v) => handleSelectChange(v, 'fabricMakerId', (v) => v === null ? null : v.value)}
          value={organisation.fabricMakerId}
      /> }

      { !isNolans && <SelectControl
          clearable={true}
          deleteRemoves={true}
          backspaceRemoves={true}
          validationMessages={validationMessages}
          labelText="Default Fabric Maker"
          name="defaultFabricMakerId"
          options={fabricMakers}
          onChange={(v) => handleSelectChange(v, 'defaultFabricMakerId', (v) => v === null ? null : v.value)}
          value={organisation.defaultFabricMakerId}
      /> }

      { !isNolans && <SelectControl
          clearable={true}
          deleteRemoves={true}
          backspaceRemoves={true}
          validationMessages={validationMessages}
          labelText="Is a Powder Coater"
          name="powderCoaterId"
          options={powderCoaters}
          onChange={(v) => handleSelectChange(v, 'powderCoaterId', (v) => v === null ? null : v.value)}
          value={organisation.powderCoaterId}
      /> }      

      { canEditGroupOrderEmails && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Group Purchase Order Email"
        value={organisation.organisationGroupPurchaseOrderEmail}
        name="organisationGroupPurchaseOrderEmail"
        validationMessages={validationMessages}
      /> }

      { canEditGroupOrderEmails && <TextBoxControl
        onChange={handleFieldChange}
        labelText="Group Sales Order Email"
        value={organisation.organisationGroupSalesOrderEmail}
        name="organisationGroupSalesOrderEmail"
        validationMessages={validationMessages}
      /> }

    </div>
  </div>)
};

CustomerAdminControl.propTypes = {
  organisation: PropTypes.object.isRequired,
  organisationGroups: PropTypes.array.isRequired,
  validationMessages: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  creditTerms: PropTypes.array.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  creditApplicationStatuses: PropTypes.array.isRequired,
  organisationStatuses: PropTypes.array.isRequired,
  dispatchTypes: PropTypes.array.isRequired,
  dispatchCentres: PropTypes.array.isRequired,
  powderCoaters: PropTypes.array.isRequired,
  fabricMakers: PropTypes.array.isRequired,
  isNolans: PropTypes.bool.isRequired,
  deliveryRegions: PropTypes.array,
  couriers: PropTypes.array,
};